export const CONTRACT_FILE_TYPES = Object.freeze({
  CONTRACT_LETTER: 0,
  TERMINATION_LETTER: 1,
});
